module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "stdapplinf-detail-pg3"
    }
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.data,
      "maxRowspan": 2
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-76298d9a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stdapplinf/stdapplinfDetailPg3.vue
// module id = 3886
// module chunks = 1